<template>
  <div class="media">
    <div v-if="trailerId" class="media__video-wrapper">
      <SampleVideo :videoId="trailerId" />
    </div>
    <div class="media__details">
      <div class="media__details-top">
        <p class="media__duration">
          <span class="lead">Duration:</span>
          <span class="data">{{ duration }}</span>
        </p>
        <p class="media__difficulty">
          <span class="lead">Difficulty:</span>
          <Difficulty :difficulty="difficulty" :colored="true" />
        </p>
      </div>
      <p class="media__activities">
        <span class="lead">Activities:</span>
        <span class="data" v-show="activities.sections > 0">
          {{ activities.sections }}
          {{ activities.sections > 1 ? 'sections' : 'section' }}
        </span>
        <span class="data" v-show="activities.courses > 0">
          , {{ activities.courses }}
          {{ activities.courses > 1 ? 'courses' : 'course' }}
        </span>
        <span class="data" v-show="activities.videos > 0"
          >, {{ activities.videos }}
          {{ activities.videos > 1 ? 'videos' : 'video' }}</span
        >
        <span class="data" v-show="activities.quizzes > 0"
          >, {{ activities.quizzes }}
          {{ activities.quizzes > 1 ? 'quizzes' : 'quiz' }}</span
        >
        <span class="data" v-show="activities.labs > 0"
          >, {{ activities.labs }}
          {{ activities.labs > 1 ? 'labs' : 'lab' }}</span
        >
        <span class="data" v-show="activities.exercises > 0"
          >, {{ activities.exercises }}
          {{ activities.exercises > 1 ? 'exercises' : 'exercise' }}</span
        >
        <span class="data" v-show="activities.iframes > 0"
          >, {{ activities.iframes }}
          {{ activities.iframes > 1 ? 'slides' : 'slide' }}</span
        >
      </p>
    </div>
    <p class="media__instructor-header lead">Instructors:</p>
    <Instructors
      :instructors="instructors"
      @search-presenter="searchPresenter"
    />
  </div>
</template>

<script>
import SampleVideo from '@/components/media/SampleVideo.vue'
import Instructors from '@/components/learning-path/overview/Instructors.vue'
import Difficulty from '../../properties/Difficulty.vue'

export default {
  name: 'Media',
  components: {
    Difficulty,
    SampleVideo,
    Instructors,
  },
  props: {
    instructors: {
      type: Array,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    duration: {
      type: String,
      required: false,
    },
    difficulty: {
      type: String,
      required: false,
    },
    activities: {
      type: Object,
      required: false,
    },
    trailerId: {
      type: String,
      required: false,
    },
  },
  methods: {
    searchPresenter(name) {
      this.$store.dispatch('search/setQuery', '')
      this.$router.push({ name: 'search', query: { Instructors: name } })
    },
  },
}
</script>

<style lang="scss" scoped>
.media {
  width: 100%;
  padding-top: 25px;
  @include tablet {
    padding-top: 50px;
    flex-grow: 1;
  }
  @include desktop {
    width: 40%;
  }
  &__video-wrapper {
    display: none;
    @include tablet {
      display: flex;
      align-items: center;
    }
  }
  &__details-top {
    display: flex;
  }
  &__difficulty {
    display: flex;
    align-items: center;
    padding-left: 25px;
    margin-left: 25px;
    border-left: 1px solid var(--gray);
  }
}
</style>
